import { call, select, take } from 'redux-saga/effects';

import { selectors as cartSelectors } from '@elab/core/store/cart';

import { selectors as userSelectors, types as userTypes } from '../../store/user';
import authCookiesManager from '../authCookiesManager';

export const getUserId = function*() {
    let userId = yield select(userSelectors.getUserId);
    const isAuthorizedInCookies = yield call(authCookiesManager.isAuthorized);

    if (!userId && isAuthorizedInCookies) {
        // case if try to load cart before profile initialization
        yield take(userTypes.SET_PROFILE);
        userId = yield select(userSelectors.getUserId);
    }

    return userId;
};

export const getCartId = function*(userId) {
    return yield select(userId ? cartSelectors.getCode : cartSelectors.getGuid);
};

export const getSeconds = (startTime, endTime) => {
    return Math.floor((endTime - startTime) / 1000);
};
